import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, deleteToken } from 'firebase/messaging';
import info from 'virtual:build-info';
import { getDeviceId, getDeviceType, getBrowserInfo, isDesktop } from '@/pages/login/helpers';
import { userApis } from '../apis/user';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

onMessage(messaging, (payload: any) => {
  console.log('=================== Message received. ', payload);
});

const requestDeviceInfo = async (push_token: string = '', first_after_login: boolean = false) => {
  const browserInfo = getBrowserInfo();
  userApis.postFCMToken({
    device_id: getDeviceId(),
    device_type: getDeviceType(),
    app_version: `HaloChat ${isDesktop() ? 'Desktop' : 'Web'} ${info.version}`,
    os_version: browserInfo.platform,
    device_name: `${browserInfo.browserName} ${browserInfo.browserVersion}`,
    push_token,
    first_after_login,
  });
};

const requestNotificationPermission = async () => {
  if ('serviceWorker' in navigator) {
    Notification.requestPermission().then(async (permission) => {
      if (permission === 'granted') {
        getToken(messaging, {
          vapidKey,
        }).then((fcmToken) => {
          if (fcmToken) {
            requestDeviceInfo(fcmToken, false);
          }
        });
      }
      if (permission === 'denied') {
        console.error('Notification permission denied');
        // Notification.requestPermission().then((permission) => {
        //   if (permission === 'granted') {
        //     requestNotificationPermission();
        //   }
        // });
      }
    });
  }
};

const deleteFCMToken = async () => {
  try {
    const token = await getToken(messaging, { vapidKey });
    if (token) {
      await deleteToken(messaging);
    }
  } catch (_) {
    // empty
  }
};

export { requestNotificationPermission, deleteFCMToken, requestDeviceInfo };
